module.exports = __webpack_public_path__ + "static/media/ReefocusLogo.cb3e32c3.svg";